const icon = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="21"
		height="27"
		version="1"
		viewBox="0 0 210 270"
	>
		<path
			fill="#000"
			stroke="none"
			d="M0 135V0h80c64 0 80 3 80 15 0 8 5 15 10 15 6 0 10 7 10 15s7 15 15 15c12 0 15 18 15 105v105H0V135z"
		></path>
		<path
			fill="#5c1f99"
			stroke="none"
			d="M0 135V0h80c64 0 80 3 80 15 0 8 5 15 10 15 6 0 10 7 10 15s7 15 15 15c12 0 15 18 15 105v105H0V135zm180 30V90h-30c-27 0-30-3-30-30 0-29-2-30-45-30H30v210h150v-75z"
		></path>
		<path
			fill="#9d9039"
			stroke="none"
			d="M0 135V0h80c64 0 80 3 80 15 0 8 5 15 10 15 6 0 10 7 10 15s7 15 15 15c12 0 15 18 15 105v105H0V135zm180 42c0-36 5-68 12-75 9-9 3-12-30-12-40 0-42-1-42-30s-2-30-45-30H30v210h150v-63z"
		></path>
		<path
			fill="#7928c9"
			stroke="none"
			d="M0 135V0h80c64 0 80 3 80 15 0 8 5 15 10 15 6 0 10 7 10 15s7 15 15 15c12 0 15 18 15 105v105H0V135zm180 42c0-36 5-68 12-75 9-9 3-12-30-12h-42V48c0-33-3-39-12-30-7 7-27 12-45 12H30v210h150v-63z"
		></path>
		<path
			fill="#0f9"
			stroke="none"
			d="M0 135V0h80c64 0 80 3 80 15 0 8 5 15 10 15 6 0 10 7 10 15s7 15 15 15 15 7 15 15c0 11-12 15-45 15h-45V48c0-33-3-39-12-30-7 7-27 12-45 12H30v210h150v-59c0-40 5-63 15-71 13-11 15-2 15 74v86H0V135z"
		></path>
		<path
			fill="#0cf"
			stroke="none"
			d="M0 255c0-12 17-15 90-15h90v-59c0-40 5-63 15-71 13-11 15-2 15 74v86H105c-87 0-105-3-105-15z"
		></path>
		<path
			fill="#f66"
			stroke="none"
			d="M120 48c0-33-3-39-12-30C90 36 0 34 0 15 0 3 16 0 80 0s80 3 80 15c0 8 5 15 10 15 6 0 10 7 10 15s7 15 15 15 15 7 15 15c0 11-12 15-45 15h-45V48z"
		></path>
		<path
			fill="#93f"
			stroke="none"
			d="M180 181c0-40 5-63 15-71 13-11 15-3 15 59 0 56-3 71-15 71s-15-13-15-59z"
		></path>
		<path
			fill="#cabe4a"
			stroke="none"
			d="M0 15C0 3 13 0 61 0c54 0 60 2 49 15C93 36 0 36 0 15z"
		></path>
		<path
			fill="#fff35c"
			stroke="none"
			d="M0 15C0 3 13 0 56 0c49 0 55 2 44 15-8 9-30 15-56 15-32 0-44-4-44-15z"
		></path>
	</svg>
);

export default icon;
